import { Controller } from "@hotwired/stimulus"

// Auto-shows the injected result modal when it lands in the DOM (via Turbo
// Stream), mirroring toast_controller. Dismissing it just closes the modal —
// the builder page and the user's edits stay put, so they can keep tweaking and
// re-reviewing. A full reset to the sample data happens only when they navigate
// away (see adj_builder_page_controller's turbo:before-cache handler).
export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element)
    this.modal.show()
    this.element.addEventListener("hidden.bs.modal", () => this.teardown())
  }

  teardown() {
    this.modal?.dispose()
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
    this.element.remove()
  }
}
